// Chart layout constants
export const CHART_MARGIN = {
  top: 20,
  right: 30,
  bottom: 70,
  left: 80,
} as const;

// Legend layout constants
export const LEGEND_WIDTH = 200;
export const LEGEND_HEIGHT = 40;
export const LEGEND_PADDING = 20;

// Visual constants
export const PATTERN_OPACITY = 0.7;
export const DEFAULT_GLYPH_SIZE = 8;

// Chart spacing constants
export const BAR_PADDING_INNER = 0.2;
export const LINE_PADDING_INNER = 0.1;

// Domain padding
export const Y_DOMAIN_PADDING = 0.1; // 10% padding on Y axis

// Animation constants
export const ANIMATION_DURATION = 300; // milliseconds

// Axis tick configuration
export const MIN_PIXELS_PER_TICK = 100; // Increased minimum to reduce density earlier
export const DEFAULT_X_TICKS = 6; // Reduced default for less crowding
export const MIN_X_TICKS = 4;
export const MAX_X_TICKS = 8; // Reduced maximum for better spacing

// Tick density thresholds (pixels per tick)
export const TICK_DENSITY_THRESHOLDS = {
  LOW: 160, // Full format: "March 2024" - increased threshold
  MEDIUM: 120, // Abbreviated: "Mar '24" - increased threshold
  HIGH: 100, // Compact: "Mar" - increased threshold
} as const;

// Width breakpoints for tick count
export const WIDTH_BREAKPOINTS = {
  SMALL: 400,
  MEDIUM: 600,
  LARGE: 800,
} as const;
